//版本比较方法
module.exports = {
  eq: function(a, b) {
    return a === b;
  },
  gt: function(a, b) {
    var splitedA = a ? a.split('.') : [];
    var splitedB = b ? b.split('.') : [];
    [0,1,2].forEach(function(i){
      splitedA[i] = splitedA[i] || 0;
      splitedB[i] = splitedB[i] || 0;
    });
    if (+splitedA[0] !== +splitedB[0]) {
      return +splitedA[0] > +splitedB[0];
    } else {
      if (+splitedA[1] !== +splitedB[1]) {
        return +splitedA[1] > +splitedB[1];
      } else {
        return +splitedA[2] > +(splitedB[2] || 0);
      }
    }
  },
  lt: function(a, b) {
    return !this.gte(a, b);
  },
  gte: function(a, b) {
    return this.eq(a, b) || this.gt(a, b);
  },
  lte: function(a, b) {
    return this.eq(a, b) || this.lt(a, b);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/common/semver.js
// module id = 49
// module chunks = 10 11 12 13 14 15 16 17 18 19